/** Captured from Clients List Columns Settings modal. */
export const LIST_COLUMNS_SETTINGS = {
  "rows": [
    {
      "value": "CLIENT NAME",
      "label": "CLIENT NAME",
      "priority": "2",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "PAYER NAME",
      "label": "PAYER NAME",
      "priority": "3",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "ADMISSION DATE",
      "label": "ADMISSION DATE",
      "priority": "3",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "PHONE NO",
      "label": "PHONE NO",
      "priority": "4",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "EMAIL ID",
      "label": "EMAIL ID",
      "priority": "5",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "DCC STATUS",
      "label": "DCC STATUS",
      "priority": "6",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "PHOTO",
      "label": "PHOTO",
      "priority": "1",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "LOC",
      "label": "LOC",
      "priority": "8",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "CARE MANAGER",
      "label": "CARE MANAGER",
      "priority": "9",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "TRANSPORTATION BROKER",
      "label": "TRANSPORTATION BROKER",
      "priority": "11",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "CLIENT ID",
      "label": "CLIENT ID",
      "priority": "12",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "MOBILITY ID #",
      "label": "MOBILITY ID #",
      "priority": "13",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "DATE OF BIRTH",
      "label": "DATE OF BIRTH",
      "priority": "14",
      "checked": true,
      "priorityDisabled": false
    },
    {
      "value": "MEDICAID ID",
      "label": "MEDICAID ID",
      "priority": "15",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "HMO ID",
      "label": "HMO ID",
      "priority": "16",
      "checked": false,
      "priorityDisabled": true
    },
    {
      "value": "ADDRESS",
      "label": "ADDRESS",
      "priority": "17",
      "checked": false,
      "priorityDisabled": true
    }
  ],
  "statusFilter": "AV",
  "statusOptions": [
    {
      "value": "Alls",
      "label": "All (Status)"
    },
    {
      "value": "AV",
      "label": "Approved / Visitor"
    },
    {
      "value": "Approved",
      "label": "Approved"
    },
    {
      "value": "Visitor",
      "label": "Visitor"
    },
    {
      "value": "Discharged",
      "label": "Discharged"
    },
    {
      "value": "Hold",
      "label": "Hold"
    }
  ]
} as const
